import { AfterViewInit, Component } from '@angular/core';
import { AuthService } from './auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  isLoggedIn = false;

  constructor(private authService: AuthService) {}

  async ngAfterViewInit() {
    try {
      const creds = await this.authService.getCreds();
      console.log(`Authenticated with id_token: ${creds.id_token}`);
      console.log(`Authenticated with session_token: ${creds.session_token}`);
      this.isLoggedIn = true;
    } catch (err) {
      console.error(err);
    }
  }
}
